// LocalStorage
// ----------------------------------------------------------
export const LOCALSTORAGE_VERSION = '1.0.0';

// Auth0
// ----------------------------------------------------------
export const AUTH0_CONFIG = {
    audience: process.env.VUE_APP_AUTH0_AUDIENCE || '',
    customAudience: process.env.VUE_APP_AUTH0_CUSTOM_AUDIENCE || '',
    clientID: process.env.VUE_APP_AUTH0_CLIENT_ID || '',
    connection: 'Username-Password-Authentication',
    domain: process.env.VUE_APP_AUTH0_DOMAIN || '',
    redirectUri: process.env.VUE_APP_SITEURL + 'auth', //loginした後の遷移先
    responseType: 'token id_token',
    returnTo: {
        default: process.env.VUE_APP_SITEURL, //logoutした後の遷移先
        changeEmail: process.env.VUE_APP_SITEURL + 'config/user/provisional' //email変更でlogoutした後の遷移先
    },
    scope: 'openid email read:current_user update:current_user_metadata'
};

// Stripe
// ----------------------------------------------------------
export const STRIPE_CONFIG = {
    apiKey: {
        default: process.env.VUE_APP_STRIPE_API_KEY,
        test: process.env.VUE_APP_STRIPE_API_KEY_TEST
    },
    style: {
        base: {
            fontSize: '14px',
            color: '#34404e',
            '::placeholder': {
                color: '#b8ccd8'
            }
        },
        invalid: {
            color: '#34404e'
        }
    }
};

// 契約プランIDリスト (一応、本番環境とそれ以外の環境は切り分けています
// ----------------------------------------------------------
export const SUBSCRIPTION_PLAN_ID = {
    invoice: process.env.VUE_APP_ENV === 'production' ? '5tyka' : '5tyka',
    invoice202305: process.env.VUE_APP_ENV === 'production' ? 'aut9c' : 'aut9c',
    invoiceLightPlan:
        process.env.VUE_APP_ENV === 'production' ? 'xpmzm' : 'xpmzm',
    stripe: {
        other: process.env.VUE_APP_ENV === 'production' ? '9fha6' : '9fha6',
        starter: process.env.VUE_APP_ENV === 'production' ? 'ed4wa' : 'ed4wa',
        basic: process.env.VUE_APP_ENV === 'production' ? 'bmkbd' : 'bmkbd'
    },
    temp: process.env.VUE_APP_ENV === 'production' ? 'hgz8w' : 'hgz8w',
    test: process.env.VUE_APP_ENV === 'production' ? 'nnp93' : 'nnp93',
    trial: process.env.VUE_APP_ENV === 'production' ? 'ef89k' : 'ef89k'
};

// サイト情報
// ----------------------------------------------------------
export const CUSTOMER_SUPPORT_EMAIL = 'customer@searchwrite.jp';
// サービスサイト
export const SERVICE_SITEURL = process.env.VUE_APP_SERVICE_SITEURL;
// コーポレートサイト
export const CORPORATE_SITEURL = 'https://www.plan-b.co.jp';
// Pinto
export const PINTO_SITEURL = 'https://service.plan-b.co.jp';
// サイト名
export const SITENAME = process.env.VUE_APP_SITENAME;
// サポートデスクサイト
export const SUPPORT_DESK_SITEURL = 'https://support.searchwrite.jp/hc/ja';
// SW LPサイト
export const LP_SITE_URL = 'https://lp.searchwrite.jp';
// LEADサイト
export const LEAD_SITE_URL = process.env.VUE_APP_LEAD_SITEURL;

// 謹告
// ----------------------------------------------------------
export const NOTIFICATION_INTERVAL_DELAY = 1000 * 60;

// アカウント
// ----------------------------------------------------------
export const PASSWORD_MIN_LENGTH = 14;

// インテント
// ----------------------------------------------------------
export const INTENT_TYPES = {
    access: {
        label: '行きたい',
        name: 'access'
    },
    buy: {
        label: '買いたい',
        name: 'buy'
    },
    'how to': {
        label: '課題解決',
        name: 'howto'
    },
    know: {
        label: '知りたい',
        name: 'know'
    },
    vs: {
        label: '比べたい',
        name: 'vs'
    },
    unknown: {
        label: '不明',
        name: 'unknown'
    }
};

// 新規キーワード発見
// ----------------------------------------------------------
export const KEYWORD_CATEGORY_LABEL = {
    lsi: 'LSI',
    related: '関連',
    suggest: 'サジェスト'
};

// 自社キーワード分析の絞り込み条件の保存に関する上限
// ----------------------------------------------------------
export const FILTER_LIMIT_VALUES = {
    // 絞り込み条件名の文字数の上限
    maxNameLength: 20,
    // 絞り込み条件のURLの最大値
    maxUrlLength: 50,
    // 絞り込み条件のキーワードの最大値
    maxKeywordLength: 50,
    // 登録できる絞り込み条件の最大値
    maxFilterLength: 50
};

// 使用量
// ----------------------------------------------------------
export const USAGE_LABEL = {
    'competitor-analyses': '関連ワード分析数',
    'competitor-site-analysis': '競合キーワード分析数',
    'content-plan-keywords': 'コンテンツ立案調査キーワード登録回数',
    'nominated-keywords': '指名キーワード登録数',
    'observation-keywords': '検索順位キーワード登録数',
    'page-checkups': 'SEO課題チェック登録回数',
    projects: 'サイト登録数',
    'research-keywords': '新規キーワード登録数',
    tasks: 'タスク登録数'
};
export const USAGE_COUNT_LABEL = {
    'observation-keywords': '検索順位キーワード月間登録数',
    project: 'サイト登録数'
};

export const USAGE_LABEL_DETAIL = {
    'competitor-analyses': '月間分析回数の上限 (再分析も含みます)',
    'competitor-site-analysis': '月間分析回数の上限',
    'content-plan-keywords': '月間キーワード登録回数の上限',
    'page-checkups': '月間URL登録回数の上限'
};

// SEO課題チェック
// ----------------------------------------------------------
export const SEO_CHECKUP_ITEM = {
    MetaTitle: {
        label: 'メタタイトルタグテスト',
        score: 3
    },
    MetaDescription: {
        label: 'メタディスクリプションタグテスト',
        score: 3
    },
    Heading: {
        label: '見出しタグのテスト',
        score: 4
    },
    HasRobot: {
        label: 'robots.txtのテスト',
        score: 2
    },
    HasSiteMap: {
        label: 'サイトマップのテスト',
        score: 4
    },
    BrokenLink: {
        label: '壊れたリンクのテスト',
        score: 4
    },
    BrokenImageLink: {
        label: 'ページの画像リンクテスト',
        score: 4
    },
    BrokenStylesheetLink: {
        label: 'ページのCSSリンクテスト',
        score: 4
    },
    BrokenScriptLink: {
        label: 'ページのJavaScriptリンクテスト',
        score: 4
    },
    CheckAlt: {
        label: '画像のAltテスト',
        score: 4
    },
    DeprecatedHtmlTag: {
        label: '非推奨HTMLタグのテスト',
        score: 1
    },
    Favicon: {
        label: 'ファビコンテスト',
        score: 1
    },
    JsError: {
        label: 'JavaScriptのエラーテスト',
        score: 2
    },
    LinkSns: {
        label: 'ソーシャルメディアのテスト',
        score: 2
    },
    HtmlSize: {
        label: 'HTMLページサイズのテスト',
        score: 3
    },
    CompressedHtml: {
        label: 'HTMLの圧縮/GZIPテスト',
        score: 2
    },
    SiteLoadingSpeedDesktop: {
        label: 'サイトの読み込み速度テスト：デスクトップ',
        score: 5
    },
    SiteLoadingSpeedMobile: {
        label: 'サイトの読み込み速度テスト：スマホ',
        score: 5
    },
    OutBoundLink: {
        label: 'ページの外部参照テスト',
        score: 1
    },
    PageCache: {
        label: 'ページキャッシュテスト\n（サーバー側のキャッシュ）',
        score: 2
    },
    UseFlash: {
        label: 'フラッシュテスト',
        score: 2
    },
    ImageCache: {
        label: 'イメージのキャッシュテスト',
        score: 2
    },
    JsCache: {
        label: 'JavaScriptのキャッシュテスト',
        score: 2
    },
    CssCache: {
        label: 'CSSのキャッシュテスト',
        score: 2
    },
    JsMinify: {
        label: 'JavaScript縮小化テスト',
        score: 2
    },
    CssMinify: {
        label: 'CSS縮小化テスト',
        score: 2
    },
    NestTable: {
        label: 'ネストされた表のテスト',
        score: 1
    },
    UseFrame: {
        label: 'フレームセットのテスト',
        score: 1
    },
    Docktype: {
        label: 'DOCTYPEテスト',
        score: 1
    },
    UrlRedirect: {
        label: 'URLリダイレクトをテスト',
        score: 1
    },
    NormalizationUrl: {
        label: 'URL正規化テスト',
        score: 4
    },
    HttpsCheck: {
        label: 'HTTPSテスト',
        score: 5
    },
    ServerSignature: {
        label: 'サーバー署名テスト',
        score: 2
    },
    DirectoryBrowsing: {
        label: 'ディレクトリの参照のテスト',
        score: 1
    },
    Email: {
        label: '平文メールテスト',
        score: 1
    },
    MediaQuery: {
        label: 'メディアクエリ応答テスト',
        score: 3
    },
    StructuredData: {
        label: '構造化データテスト',
        score: 3
    },
    CanonicalCheck: {
        label: 'URLの正規化テスト\n（Canonicalのタグテスト）',
        score: 5
    },
    NoFollowCheck: {
        label: 'nofollowタグのテスト',
        score: 3
    },
    NoIndexCheck: {
        label: 'noindexタグのテスト',
        score: 5
    },
    CrawlAvoidance: {
        label: '指令のテストを禁止',
        score: 2
    },
    UseHttp2: {
        label: 'HTTP2テスト',
        score: 1
    }
};

// タスク
// ----------------------------------------------------------
export const TASK_LENGTHS_LIMIT = 1000;
export const PROPOSAL_TASK_DETAIL = {
    changeTd:
        '「{{keyword}}」でタイトル・ディスクリプションを変更してみましょう\nキーワード「{{keyword}}」について、順位が高く、表示回数が多いわりに、クリック率が少ないキーワードとなっています。コンテンツのタイトル・ディスクリプションを変更してみましょう。',
    rewrite:
        '「{{keyword}}」の順位をコンテンツのリライトで改善しましょう！\nキーワード「{{keyword}}」について、検索ボリュームが多く、惜しい順位（6位～50位）のキーワードとなっています。コンテンツの「網羅性」「独自性」「専門性」を見直してみましょう。',
    seoCheckUp: {
        MetaTitle:
            'メタタイトルタグを変更してページ評価を改善しましょう！\nメタタイトルタグが全角文字32文字以下・半角文字64文字以下になっているかを確認する',
        MetaDescription:
            'メタディスクリプションタグを変更してページ評価を改善しましょう！\nメタディスクリプションタグが全角文字120文字以下・半角文字240文字以下になっているかを確認する',
        Heading:
            '見出しタグを追加してページ評価を改善しましょう！\nページにh1とh2タグを使用した見出しが存在するかを確認する',
        HasRobot:
            'robots.txtを設置してページ評価を改善しましょう！\nWebサイトにrobots.txtが設置されているかを確認する',
        HasSiteMap:
            'サイトマップを設置してページ評価を改善しましょう！\nWebサイトにサイトマップが設置されているかを確認する',
        BrokenLink:
            '壊れたリンクを修正してページ評価を改善しましょう!\nページに無効なリンクが存在しないかを確認する',
        BrokenImageLink:
            '画像のリンク切れを解消してページ評価を改善しましょう！\nページに画像のリンク切れが存在しないかを確認する',
        BrokenStylesheetLink:
            'CSSのリンク切れを解消してページ評価を改善しましょう！\nページにCSSのリンク切れが存在しないかを確認する',
        BrokenScriptLink:
            'JavaScriptのリンク切れを解消してページ評価を改善しましょう！\nページにJavaScriptのリンク切れが存在しないかを確認する',
        CheckAlt:
            '画像タグにalt属性を設定してページ評価を改善しましょう！\nページにalt属性が設定されていない画像タグが存在しないかを確認する',
        DeprecatedHtmlTag:
            '非推奨HTMLタグを修正してページ評価を改善しましょう！\nページに非推奨HTMLタグが使用されていないかを確認する',
        Favicon:
            'エラーが発生しているJavaScriptを修正してページ評価を改善しましょう！\nWebサイトにファビコンを設定してページ評価を改善しましょう！\nWebサイトにファビコンを設置されているかを確認する',
        JsError:
            'エラーが発生しているJavaScriptを修正してページ評価を改善しましょう！\nページでスクリプトエラーが発生していないかを確認する',
        LinkSns:
            'ソーシャルメディアへのリンクを設置してページ評価を改善しましょう！\nページにソーシャルメディアへのリンクが設置されているかを確認する',
        HtmlSize:
            'HTMLのページサイズを改善して表示速度を改善しましょう！\nページのHTMLサイズが33KB以内に収まっているかを確認する',
        CompressedHtml:
            'HTMLを圧縮してページ評価を改善しましょう！\nWebサイトを公開しているサーバーからのレスポンスがHTMLを圧縮したものになっているかを確認する',
        SiteLoadingSpeedDesktop:
            'サイトの読み込み速度を改善して表示速度を改善しましょう！\nPCサイトの読み込み速度が4.3秒以内に収まっているかを確認する',
        SiteLoadingSpeedMobile:
            'サイトの読み込み速度を改善して表示速度を改善しましょう！\nMOBILEサイトの読み込み速度が4.3秒以内に収まっているかを確認する',
        OutBoundLink:
            '外部参照ファイル数を改善して表示速度を改善しましょう！\nページに設置している外部参照ファイルへのリンク数が20個以下になっているかを確認する',
        PageCache:
            'ページキャッシュを有効にして表示速度を改善しましょう！\nページのキャッシュ設定が有効にあっているかを確認する',
        UseFlash:
            'Flashタグが設置されているコンテンツを修正してページ評価を改善しましょう！\nページにFlashタグが設置されていないかを確認する',
        ImageCache:
            '画像キャッシュを有効にして表示速度を改善しましょう！画像のキャッシュ設定が有効にあっているかを確認する',
        JsCache:
            'JavaScriptのキャッシュを有効にして示速度を改善しましょう！JavaScriptのキャッシュ設定が有効にあっているかを確認する',
        CssCache:
            'CSSのキャッシュを有効にして表示速度を改善しましょう！CSSのキャッシュ設定が有効にあっているかを確認する',
        JsMinify:
            'JavaScriptを縮小して表示速度を改善しましょう！\n読み込んでいるJavaScriptが縮小されているかを確認する',
        CssMinify: '読み込んでいるCSSが縮小されているかを確認する',
        NestTable:
            'CSSを縮小して表示速度を改善しましょう！\nページにネストしたテーブルタグが存在しないかを確認する',
        UseFrame:
            'frameタグが設置されているコンテンツを修正してページ評価を改善しましょう！\nページにframeタグが存在しないかを確認する',
        Docktype:
            'Doctype宣言を正しく記述してページ評価を改善しましょう！\nネストされたテーブルタグを修正して表示速度を改善しましょう！\nページに<!DOCTYPE html>が記述されているかを確認する',
        UrlRedirect:
            'ページのリダイレクト設定を修正してページ評価を改善しましょう！\nページのリダイレクト回数が1回以内に収まっているかを確認する',
        NormalizationUrl:
            'URLを正規化してページ評価を改善しましょう！\nページのURLが正規化されているかを確認する',
        HttpsCheck:
            'ページのHTTPS化を行いセキュリティ評価を改善しましょう！\nページがHTTPS化されているかを確認する',
        ServerSignature:
            'サーバー署名機能をオフにしてセキュリティ評価を改善しましょう！\nWebサイトを公開しているサーバーの署名がオフになっているかを確認する',
        DirectoryBrowsing:
            'サーバーのディレクトリ参照を無効にしてセキュリティ評価を改善しましょう！\nWebサイトを公開しているサーバーのディレクトリ参照が無効になっているかを確認する',
        Email:
            'html内のメールアドレス形式の文字列を修正してセキュリティ評価を改善しましょう！\nページに平文でメールアドレスが記述されていないかを確認する',
        MediaQuery:
            'メディアクエリを使用してページのモバイルユーザービリティを改善しましょう！\nページが読み込んでいるCSSにメディアクエリが使用されているかを確認する',
        StructuredData:
            '構造化データをマークアップしてページ評価を改善しましょう！\nページに構造化データがマークアップされているかを確認する',
        CanonicalCheck:
            'canonicalタグの設置を行い、URLの正規化しページ評価を改善しましょう！\nページにcanonicalタグが設置されているかを確認する',
        CrawlAvoidance:
            'robots.txtにクロール回避の指示を記入しましょう！\nrobots.txtにクロール回避の指示が記述されているかを確認する',
        UseHttp2:
            'WebサイトのHttp2対応を行いページ評価を改善しましょう！\nWebサイトがHttp2に対応しているかを確認する',
        NoIndexCheck:
            'ページに意図していないnoindex設定が行われていないかチェックしましょう！\nページに意図していないnoindex設定が行われていないかを確認する',
        NoFollowCheck:
            'ページ内に設置されているリンクに意図していないnofollow属性の設定がないかチェックしましょう！\nページ内に設置されているリンクに意図していないnofollow属性の設定が行われていないかを確認する'
    },
    createContent: '「{{keyword}}」で新しいコンテンツを作成しましょう！'
};

// カレンダー
// ----------------------------------------------------------
export const CALENDAR = (() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // GAのデータを取得できる期間: 16ヶ月前～1日前
    let gaMaxDate = new Date(today);
    gaMaxDate.setDate(gaMaxDate.getDate() - 1);
    let gaMinDate = new Date(gaMaxDate);
    gaMinDate.setMonth(gaMinDate.getMonth() - 16);
    gaMinDate.setDate(gaMinDate.getDate() + 1);

    // サチコのデータを取得できる期間: 16ヶ月前～3日前
    let gscMaxDate = new Date(today);
    gscMaxDate.setDate(gscMaxDate.getDate() - 3);
    let gscMinDate = new Date(gscMaxDate);
    gscMinDate.setMonth(gscMinDate.getMonth() - 16);
    gscMinDate.setDate(gscMinDate.getDate() + 1);

    // デモサイト用に固定する期間を設定
    // 以下の日付を変更する場合はデモサイトのダッシュボード、検索順位チェックに
    // 影響がでるので必ずチェックしてください。
    const demoDay = new Date(process.env.VUE_APP_DEMO_DATE);
    demoDay.setHours(0, 0, 0, 0);

    // GA
    let gaDemoMaxDate = new Date(demoDay);
    gaDemoMaxDate.setDate(gaDemoMaxDate.getDate() - 1);
    let gaDemoMinDate = new Date(gaDemoMaxDate);
    gaDemoMinDate.setMonth(gaDemoMaxDate.getMonth() - 16);
    gaDemoMinDate.setDate(gaDemoMaxDate.getDate() + 1);

    // GSC
    let gscDemoMaxDate = new Date(demoDay);
    gscDemoMaxDate.setDate(gscDemoMaxDate.getDate() - 3);
    let gscDemoMinDate = new Date(gscDemoMaxDate);
    gscDemoMinDate.setMonth(gscDemoMaxDate.getMonth() - 16);
    gscDemoMinDate.setDate(gscDemoMaxDate.getDate() + 1);

    return {
        ga: {
            maxDate: gaMaxDate,
            minDate: gaMinDate,
            days: 30
        },
        gsc: {
            maxDate: gscMaxDate,
            minDate: gscMinDate,
            days: 30
        },
        siteImportantKeyword: {
            maxDate: gscMaxDate,
            minDate: gscMinDate,
            days: 90
        },
        demoGa: {
            maxDate: gaDemoMaxDate,
            minDate: gaDemoMinDate,
            days: 30
        },
        demoGsc: {
            maxDate: gscDemoMaxDate,
            minDate: gscDemoMinDate,
            days: 30
        },
        demoSiteImportantKeyword: {
            maxDate: gscDemoMaxDate,
            minDate: gscDemoMinDate,
            days: 90
        }
    };
})();

// Error Message
// ----------------------------------------------------------
export const ERROR_MESSAGE = {
    auth0: {
        access_denied: 'メールアドレスかパスワードが間違っています',
        invalid_password:
            '半角英数字(大文字小文字)と記号(!@#$%^&*)を含んだ14文字以上にしてください',
        too_many_attempts:
            '何度もログインに失敗したため、アカウントをブロックしました',
        user_exists: 'このメールアドレスはすでに登録されています',
        extensibility_error: '代理店コードが正しくありません'
    },
    ga: {
        no_account: 'GAのアカウントがありません'
    },
    ga4: {
        no_account: 'GA4のアカウントがありません',
        no_property: 'GA4のプロパティがありません',
        no_data_stream: 'GA4のデータストリームがありません'
    },
    gsc: {
        no_site: 'サイトがありません'
    },
    other: 'エラーが発生しました'
};

// Page Meta
// ----------------------------------------------------------
export const PAGES = {
    auth: {
        title: '認証中'
    },
    competitiveKeyword: {
        title: '関連ワード分析',
        suggestAnalysis: {
            title: '関連ワード分析結果'
        }
    },
    competitiveSiteKeyword: {
        title: '競合キーワード分析',
        competitiveSiteKeywordResult: {
            title: '競合キーワード分析結果'
        }
    },
    config: {
        title: 'ユーザー情報・各種設定',
        project: {
            title: 'サイト設定'
        },
        provisional: {
            title: 'メールアドレスの変更を受け付けました'
        }
    },
    projects: {
        title: 'サイト一覧'
    },
    error: {
        title: 'エラーが発生しました'
    },
    error404: {
        title: 'ページが見つかりませんでした'
    },
    errorAccount: {
        title: 'アカウントが有効ではありません'
    },
    errorNoProject: {
        title: 'サイトが登録されていません'
    },
    login: {
        title: 'ログイン'
    },
    organization: {
        title: 'お客様一覧'
    },
    payment: {
        card: {
            title: 'クレジットカード情報入力'
        },
        plan: {
            title: 'ご利用プラン選択'
        },
        select: {
            title: 'お支払い方法選択'
        }
    },
    register: {
        confirm: {
            title: '会員登録確認'
        },
        error: {
            title: '認証エラー'
        },
        input: {
            title: '会員登録'
        },
        provisional: {
            title: '仮登録完了'
        },
        register: {
            title: '本登録完了'
        },
        trial: {
            title: '無料トライアル登録',
            confirm: {
                title: '無料トライアル登録確認'
            }
        }
    },
    reportDownload: {
        title: 'レポートダウンロード'
    },
    resetPassword: {
        title: 'パスワード再設定',
        confirm: {
            title: '送信完了'
        }
    },
    searchVolume: {
        title: '検索ボリューム調査'
    },
    seo: {
        title: 'SEO課題チェック',
        result: {
            title: 'SEO課題チェック結果'
        }
    },
    set: {
        title: 'サイト名の設定',
        confirm: {
            title: 'データ連携を始めます'
        },
        error_ga: {
            title: 'Google Analytics認証エラー'
        },
        error_gsc: {
            title: 'Google Search Console認証エラー'
        },
        gsc: {
            title: 'Google Search Console連携'
        },
        select_ga: {
            title: 'Google Analytics連携'
        },
        select_gsc: {
            title: 'Google Search Console連携'
        }
    },
    siteImportantKeyword: {
        title: '成果チェック'
    },
    siteKeywordAnalysis: {
        title: '自社キーワード分析'
    },
    contentPlans: {
        title: 'コンテンツ立案',
        contentPlansSuggest: {
            title: 'サジェストマップ'
        },
        contentPlansSurvey: {
            title: 'コンテンツ調査'
        },
        contentPlansWriting: {
            title: 'タイトル・見出し設計'
        }
    },
    taskList: {
        title: 'タスクリスト'
    },
    siteSummary: {
        title: 'GA・GSCデータサマリー'
    },
    dashboard: {
        title: 'ダッシュボード'
    },
    contentRewrite: {
        title: 'AIリライト提案 (Beta)'
    }
};

// GAバージョン設定のキー名
export const GA_VERSION_KEY = {
    gaGscDataSummary: 'gaGscDataSummary',
    siteKeywordAnalysis: 'siteKeywordAnalysis',
    siteImportantKeyword: 'siteImportantKeyword'
};

// リダイレクトの設定
// ----------------------------------------------------------
export const REDIRECT_IGNORE_PATHS = [/^\/set($|\/)/, /^\/error/];

// 日付のMAX値。降順に並べるときにnullのものを上に並べる場合などに使用
export const MAX_DATE = '2100-12-31T15:00:00Z';

// コンテンツ立案のTDHの最大文字数
export const MAX_TDH_STRING_LENGTH = 300;
